import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Dropdown,
  Button
} from 'semantic-ui-react'
import {
  Table
} from 'react-lib/frameworks/Table'

const CardAppointmentUsageHistoryUX = (props: any) => {
    return(
      <div
        id="CardAppointmentUsageHistoryUX-div-0"
        style={{width: "100%"}}>
        <div
          id="CardAppointmentUsageHistoryUX-div-1"
          style={{display: props.hideTitle?"none":"flex", alignItems: "center", justifyContent: "space-between", padding: "15px 10px", backgroundColor: "#F2F2F2"}}>
          
          <div
            id="CardAppointmentUsageHistoryUX-div-3"
            style={{fontSize: "1.2rem", fontWeight: "bold", color: "#0072BC"}}>
            {props.languageUX === "en" ? "Appointment History & Package Usage" : "ประวัติการนัดหมาย & ใช้งานแพ็กเกจ"}
          </div>
        </div>
        <div
          className="ui divider"
          id="CardAppointmentUsageHistoryUX-div-2"
          style={{marginTop: 0, border: "none"}}>
          
        </div>
        <div
          id="CardAppointmentUsageHistoryUX-div-4"
          style={{padding: "0 15px"}}>
          
          <div
            className="ui form"
            id="CardAppointmentUsageHistoryUX-div-5">
            
            <FormGroup
              id="CardAppointmentUsageHistoryUX-FormGroup-6"
              inline={true}>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-41"
                inline={true}>
                <label
                  id="CardAppointmentUsageHistoryUX-label-55"
                  style={{width: "105px"}}>
                  {props.languageUX === "en" ? "Package name/code" : "ชื่อ/รหัสแพ็กเกจ"}
                </label>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-42"
                inline={true}
                width={4}>
                <div
                  id="CardAppointmentUsageHistoryUX-div-58"
                  style={{width: "100%"}}>
                  {props.SearchBoxPackageName}
                </div>
              </FormField>
              <FormField
                className={true}
                id="CardAppointmentUsageHistoryUX-FormField-43">
                <label
                  id="CardAppointmentUsageHistoryUX-label-56"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Service type" : "ประเภทบริการ"}
                </label>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-44"
                inline={true}
                width={4}>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardAppointmentUsageHistoryUX-Dropdown-60"
                  name="serviceType"
                  onChange={props.onChangeValue}
                  options={props.packageServiceTypeOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterAppointmentHistory?.serviceType || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-45"
                inline={true}>
                <label
                  id="CardAppointmentUsageHistoryUX-label-57"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "Product name/code" : "ชื่อ/รหัสสินค้า"}
                </label>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-46"
                inline={true}
                width={4}>
                <div
                  id="CardAppointmentUsageHistoryUX-div-59"
                  style={{width: "100%"}}>
                  {props.SearchBoxProductName}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="CardAppointmentUsageHistoryUX-FormGroup-19"
              inline={true}>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-47"
                inline={true}>
                <label
                  id="CardAppointmentUsageHistoryUX-label-61"
                  style={{width: "105px"}}>
                  {props.languageUX === "en" ? "Appointment date" : "วันที่นัดหมาย"}
                </label>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-48"
                inline={true}
                width={4}>
                <div
                  id="CardAppointmentUsageHistoryUX-div-69"
                  style={{width: "100%"}}>
                  {props.StartDate}
                </div>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-49"
                inline={true}>
                <label
                  id="CardAppointmentUsageHistoryUX-label-63"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "to" : "ถึง"}
                </label>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-50"
                inline={true}
                width={4}>
                <div
                  id="CardAppointmentUsageHistoryUX-div-70"
                  style={{width: "100%"}}>
                  {props.EndDate}
                </div>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-51"
                inline={true}>
                <label
                  id="CardAppointmentUsageHistoryUX-label-65"
                  style={{minWidth: "max-content"}}>
                  {props.languageUX === "en" ? "status" : "สถานะ"}
                </label>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-52"
                inline={true}
                width={4}>
                <Dropdown
                  clearable={true}
                  fluid={true}
                  id="CardAppointmentUsageHistoryUX-Dropdown-66"
                  name="status"
                  onChange={props.onChangeValue}
                  options={props.appointmentStatusOptions || []}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.filterAppointmentHistory?.status|| ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-53"
                inline={true}>
                <div
                  id="CardAppointmentUsageHistoryUX-div-71">
                  {props.ButtonSearch}
                </div>
              </FormField>
              <FormField
                id="CardAppointmentUsageHistoryUX-FormField-54"
                inline={true}>
                <Button
                  color="yellow"
                  id="CardAppointmentUsageHistoryUX-Button-68"
                  onClick={props.onClear}>
                  {props.languageUX === "en" ? "clear" : "เคลียร์"}
                </Button>
              </FormField>
            </FormGroup>
          </div>
          <div
            className="ui form"
            id="CardAppointmentUsageHistoryUX-div-39"
            style={{marginTop: "1.5rem"}}>
            
            <Table
              data={props.appointmentHistoryItems}
              headers={props.languageUX === "en" ? "Datetime,Package name,Code,Product name/code,Qty,Status" : "วันเวลา,ชื่อแพ็กเกจ,รหัส,สินค้า/บริการ,จำนวน,สถานะ"}
              id="CardAppointmentUsageHistoryUX-Table-40"
              keys="date,name,code,service,qty,status"
              minRows={3}
              showPagination={false}
              style={{maxHeight: "calc(100vh - 23.5rem)"}}
              widths="120,,100,,80,120">
            </Table>
          </div>
        </div>
      </div>
    )
}


export default CardAppointmentUsageHistoryUX

export const screenPropsDefault = {"language":"EN","price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Fri Sep 11 2026 17:28:26 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{display: props.hideTitle?\"none\":\"flex\", alignItems: \"center\", justifyContent: \"space-between\", padding: \"15px 10px\", backgroundColor: \"#F2F2F2\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: 0, border: \"none\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการนัดหมาย & ใช้งานแพ็กเกจ",
          "valueEN": "Appointment History & Package Usage"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.2rem\", fontWeight: \"bold\", color: \"#0072BC\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0 15px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 19,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormGroup-19"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.5rem\"}"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 40,
      "name": "Table",
      "parent": 39,
      "props": {
        "data": {
          "type": "code",
          "value": "props.appointmentHistoryItems"
        },
        "headers": {
          "type": "value",
          "value": "วันเวลา,ชื่อแพ็กเกจ,รหัส,สินค้า/บริการ,จำนวน,สถานะ",
          "valueEN": "Datetime,Package name,Code,Product name/code,Qty,Status"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-Table-40"
        },
        "keys": {
          "type": "value",
          "value": "date,name,code,service,qty,status"
        },
        "minRows": {
          "type": "code",
          "value": "3"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{maxHeight: \"calc(100vh - 23.5rem)\"}"
        },
        "widths": {
          "type": "value",
          "value": "120,,100,,80,120"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-41"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormField",
      "parent": 6,
      "props": {
        "className": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 6,
      "props": {
        "className": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-43"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 44,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-44"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-49"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-50"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-52"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "4"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 19,
      "props": {
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 55,
      "name": "label",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ/รหัสแพ็กเกจ",
          "valueEN": "Package name/code"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-label-55"
        },
        "style": {
          "type": "code",
          "value": "{width: \"105px\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 43,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทบริการ",
          "valueEN": "Service type"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-label-56"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "label",
      "parent": 45,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ/รหัสสินค้า",
          "valueEN": "Product name/code"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-label-57"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 42,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxPackageName"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "code",
          "value": "props.SearchBoxProductName"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Dropdown",
      "parent": 44,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-Dropdown-60"
        },
        "name": {
          "type": "value",
          "value": "serviceType"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.packageServiceTypeOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterAppointmentHistory?.serviceType || \"\""
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "label",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่นัดหมาย",
          "valueEN": "Appointment date"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-label-61"
        },
        "style": {
          "type": "code",
          "value": "{width: \"105px\"}"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "label",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึง",
          "valueEN": "to"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-label-63"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "label",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "status"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-label-65"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "Dropdown",
      "parent": 52,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-Dropdown-66"
        },
        "name": {
          "type": "value",
          "value": "status"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.appointmentStatusOptions || []"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.filterAppointmentHistory?.status|| \"\""
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "Button",
      "parent": 54,
      "props": {
        "children": {
          "type": "value",
          "value": "เคลียร์",
          "valueEN": "clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-Button-68"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClear"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 48,
      "props": {
        "children": {
          "type": "code",
          "value": "props.StartDate"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 50,
      "props": {
        "children": {
          "type": "code",
          "value": "props.EndDate"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 53,
      "props": {
        "children": {
          "type": "code",
          "value": "props.ButtonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardAppointmentUsageHistoryUX-div-71"
        }
      },
      "seq": 71,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardAppointmentUsageHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN",
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
